// Our domains, like {prodUrl}/eu or {prodUrl}/au
export const regionAppPath = ['eu', 'au'] as const
export enum RegionAppPath {
   eu = 'eu',
   au = 'au',
}
export type RegionAppPathUnion = `${RegionAppPath}`

export const allAWSAppRegions = ['ap-southeast-2', 'eu-west-2'] as const
export type AllAWSAppRegions = (typeof allAWSAppRegions)[number]

export const awsCentralRegion = 'us-east-1' as const
export type AwsCentralRegion = typeof awsCentralRegion

export const primaryAppRegion: AllAWSAppRegions = 'ap-southeast-2'
export type PrimaryAppRegion = typeof primaryAppRegion

export const nonPrimaryAppRegions = ['eu-west-2'] as AllAWSAppRegions[]
export type NonPrimaryAppRegion = (typeof nonPrimaryAppRegions)[number]

// Map the regions we deploy to to our front end domain paths
export const regionPathMap: Record<AllAWSAppRegions, RegionAppPath> = {
   'ap-southeast-2': RegionAppPath.au,
   'eu-west-2': RegionAppPath.eu,
}

export const currentAppRegion =
   typeof process !== 'undefined' && process.env.APP_REGION ? regionPathMap[process.env.APP_REGION as AllAWSAppRegions] : undefined

export const domainRegionMap: Record<RegionAppPath, AllAWSAppRegions> = Object.entries(regionPathMap).reduce((acc, [key, value]) => {
   acc[value] = key
   return acc
}, {} as any)

export const allAppRegions = [primaryAppRegion, ...nonPrimaryAppRegions] as AllAWSAppRegions[]

/**
 * Determines if an org's XPM sync can run in the given region.
 * - NZ/AU orgs: can only sync in AU region (ap-southeast-2)
 * - Other orgs: can only sync in EU region (eu-west-2)
 */
export function canSyncXpmInRegion(countryCode: string | undefined, currentRegion: AllAWSAppRegions | RegionAppPath | RegionAppPathUnion): boolean {
   const isAuNzOrg = countryCode === 'NZ' || countryCode === 'AU'

   // Handle both AWS region format and URL path format
   if (currentRegion === 'ap-southeast-2' || currentRegion === 'au') {
      return isAuNzOrg
   }
   if (currentRegion === 'eu-west-2' || currentRegion === 'eu') {
      return !isAuNzOrg
   }
   return false
}

/**
 * Gets the required region for XPM sync based on org's country code.
 * Returns both AWS region and URL path formats.
 */
export function getRequiredXpmSyncRegion(countryCode: string | undefined): { awsRegion: AllAWSAppRegions; urlPath: RegionAppPath; name: string } {
   const isAuNzOrg = countryCode === 'NZ' || countryCode === 'AU'
   return isAuNzOrg
      ? { awsRegion: 'ap-southeast-2', urlPath: RegionAppPath.au, name: 'AU' }
      : { awsRegion: 'eu-west-2', urlPath: RegionAppPath.eu, name: 'EU' }
}
